import styled from 'styled-components';

export const EntityTitle = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: spotify-circular, Helvetica, Arial, sans-serif;
  font-size: 14px;
  letter-spacing: 0.25px;
`;
